module.exports = __webpack_public_path__ + "3f2f922d20e49ec5acf88f59ef0fa21e.svg";